import { DATE_FORMAT_SLASH_SHORT } from '@findy-code/utils/date';
import { DateTime } from '@findy-code/yuffie/shared/date-time';
import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';

import styles from './company-detail-press-release.component.module.scss';
import { SectionLayout } from './section-layout.component';

type PressReleaseEntry = {
  id: number;
  title: string;
  publishedAt: string;
  url: string;
};

type Props = {
  entries: PressReleaseEntry[];
};

export const CompanyDetailPressRelease = ({ entries }: Props) => {
  return (
    <SectionLayout heading={{ title: 'プレスリリース' }} id="press-release">
      <Stack spacing="m">
        {entries.map(({ id, url, title, publishedAt }) => (
          <article className={styles.entryItemCard} key={id}>
            <Heading as="h3" className={styles.cardTitle} font="heading-m">
              <a href={url} rel="noopener noreferrer" target="_blank">
                {title}
              </a>
            </Heading>
            <DateTime dateTime={publishedAt} format={DATE_FORMAT_SLASH_SHORT} />
          </article>
        ))}
      </Stack>
    </SectionLayout>
  );
};
